import {
  UPDATE_BILLER_CATEGORY,
  UNLOAD_BILLER_CATEGORY,
  BILLER_CATEGORY_FETCHED_SUCCESS,
  RESET_BILLER_CATEGORY,
} from '../../constants/actionTypes';

const initialState = {
  billerCategory: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_BILLER_CATEGORY:
      return {
        ...state,
        message: action.payload.msg,
      };

    case RESET_BILLER_CATEGORY:
      return {
        ...state,
        message: '',
      };

    case BILLER_CATEGORY_FETCHED_SUCCESS:
      return {
        ...state,
        billerCategory: action.payload.billerCategory.map((item) => {
          const newItem = { ...item, id: item.id };
          return newItem;
        }),
        pager: action.payload.pager,
      };

    case UNLOAD_BILLER_CATEGORY:
      return initialState;

    default:
      return state;
  }
};
